<nz-modal
  [nzMaskClosable]="false"
  [(nzVisible)]="isVisible"
  [nzTitle]="modalTitle"
  [nzContent]="modalContent"
  [nzFooter]="modalFooter"
  (nzOnCancel)="handleCancel()"
  [nzWidth]="1800"
  >
  <ng-template #modalTitle>{{ title }}</ng-template>

  <ng-template #modalContent>
    <nz-table appColumnLayout
      nzShowSizeChanger
      [nzData]="history"
      [nzLoading]="isLoading"
      [nzFrontPagination]="false"
      id="voucher-history-table"
      >
      <thead>
        <tr>
          <th nzColumnKey="id" nzWidth="75px">#ID</th>
          <th nzColumnKey="orderNumber">Bestellnummer</th>
          <th nzColumnKey="code">Code</th>
          <th nzColumnKey="amount">Betrag</th>
          @if (!isPercentage) {
            <th nzColumnKey="remainingAmount">Verbleibender Betrag</th>
          }
          <th nzColumnKey="createdBy">Erstellt von</th>
          <th nzColumnKey="updatedBy">Aktualisiert von</th>
          <th nzColumnKey="createdAt">Erstellt am</th>
          <th nzColumnKey="updatedAt">Aktualisiert am</th>
          <th nzColumnKey="status">Status</th>
          @if (!isPercentage) {
            <th nzColumnKey="soldAt">Datum des Verkaufs</th>
          }
          <th nzColumnKey="store">Betrieb</th>
        </tr>
      </thead>
      <tbody>
        @for (item of history; track item) {
          <tr>
            <td>{{ item.id }}</td>
            <td>{{ item.orderNumber }}</td>
            <td>{{ item.code }}</td>
            <td nzAlign="right" class="cell-numeric cell-nowrap">{{ isPercentage ? ((item.amount | number:'1.0-2') + ' %') : (item.amount | currency) }}</td>
            @if (!isPercentage) {
              <td>{{ item.remainingAmount | currency }}</td>
            }
            <td>{{ item.createdBy }}</td>
            <td>{{ item.updateBy }}</td>
            <td>{{ item.createdAt | datetimeFormat }}</td>
            <td>{{ item.updatedAt | datetimeFormat }}</td>
            <td>{{ voucherCodeStatuses[item.status] }}</td>
            @if (!isPercentage) {
              <td>{{ item.saleDate | datetimeFormat }}</td>
            }
            <td>{{ voucherHistoryOperations[item.operation] }}</td>
          </tr>
        }
      </tbody>
    </nz-table>
  </ng-template>

  <ng-template #modalFooter>
    <button nz-button nzType="default" (click)="handleCancel()">Schließen</button>
  </ng-template>
</nz-modal>
